import { Link } from "react-router-dom";
import { useTheme } from "styled-components";

function BCLinkReactRouterDom({ to, text }) {
  const theme = useTheme();
  return (
    <Link
      to={to}
      style={{
        color: theme.links,
        textDecoration: "underline",
      }}
    >
      {text}
    </Link>
  );
}

export default BCLinkReactRouterDom;
